// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__FqddA","content":"Page_content__7hHlv","scrollingDisabled":"Page_scrollingDisabled__3CyGR"};